<template>
    <v-dialog
    v-model="dialogLastOrder"                
    width="500"
    persistent
    >        
        <v-card>
            <v-card-title
            class="grey lighten-2 title"
            primary-title
            >
            <div>
                Ya existen productos en la cesta    <br>                 
            </div>                                             
            </v-card-title>                            
            <v-card-text>
                Seleccione una opción
            </v-card-text>                        
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                flat
                @click="closeDialog()"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="primary"
                flat
                @click="closeDialogAdd()"
            >
                Añadir a la cesta
            </v-btn>
            <v-btn                
                color="success"
                flat                
                @click="closeOKDialog()"
            >
                Reemplazar cesta
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>
export default {
    name: 'dialogLastOrder',
    data () {
      return {             
         
      }
    },
    methods:{                
        closeDialog(){           
            this.dialogLastOrder = false;
        },
        closeDialogAdd(){           
            this.dialogLastOrder = false;
            this.lastOrder(false,this.dialogLastOrderData.docType,this.dialogLastOrderData.docNo);
        },
        closeOKDialog(){
            this.$store.commit("resetOrderItems");
            this.dialogLastOrder = false;
            this.lastOrder(false,this.dialogLastOrderData.docType,this.dialogLastOrderData.docNo);
        }
    },
    computed: {     
        dialogLastOrder:{
            get(){
                return this.$store.state.dialogLastOrder;
            },
            set(value){
                this.$store.state.dialogLastOrder = value;
            }
        },
        dialogLastOrderData:{
            get(){
                return this.$store.state.dialogLastOrderData;
            }
        }
    } 
}
</script>

